/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'sort': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M32 16.5v16c0 .275-.225.5-.5.5h-2a.501.501 0 0 1-.5-.5V19H15.542c-.275 0-.542-.225-.542-.5v-2c0-.275.267-.5.542-.5H31.5c.275 0 .5.225.5.5zM11.5 20c-.275 0-.5.225-.5.5v16c0 .275.225.5.5.5h16c.275 0 .5-.225.5-.5V20H11.5zm24-8H19.542c-.275 0-.542.225-.542.5v2c0 .275.267.5.542.5H33v13.5c0 .275.225.5.5.5h2c.275 0 .5-.225.5-.5v-16c0-.275-.225-.5-.5-.5z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/sort.js